import React, { FC } from 'react';
import { JBanner } from '../JBanner';
import { JCMSBannerProps } from '../JBanner/components';

/**
 * @deprecated
 * @param props 
 * @returns 
 */
export const JCMSBanner: FC<JCMSBannerProps> = (props) => {
    return (
        <JBanner.CMS {...props}/>
    )
}

